module.exports = __webpack_public_path__ + "img/slot-pg.e1871b84.png";